import React from 'react';
import {cn} from 'src/lib/utils';

export const PopoverMenuDivider = (props: React.HTMLProps<HTMLDivElement>) => {
  const {className, ...rest} = props;
  return (
    <div
      className={cn('border-border h-px border-b', className)}
      role="separator"
      {...rest}
    />
  );
};

// Heading for a group of menu items: labels everything that follows until the
// next divider. Purely presentational — not focusable, not a menu item.
export const PopoverMenuGroupLabel = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div
    className="text-muted-foreground px-2 pt-2.5 pb-1 text-xs font-medium tracking-wide uppercase"
    role="presentation"
  >
    {children}
  </div>
);
